var scrollMonitor = require('scrollmonitor')

$(window).on('load', function() {

  $fade_in_effects = $( ".instagram-image__picture" );

  $fade_in_effects.each( function() {

      var $fade_effect = $( this );
      var elementWatcher = scrollMonitor.create( $fade_effect );

      elementWatcher.enterViewport( function() {

          TweenMax.staggerTo( ".instagram-image__picture", 2, { opacity: 1 }, 0.1 );

      } );
  } );

} );

$( document ).ready( function() {

  // ANIMATE EFFECTS

    // TweenMax.staggerTo()

      var $fade_in_effects = $( ".element-item a" );

        $fade_in_effects.each( function() {

            var $fade_effect = $( this );
            var elementWatcher = scrollMonitor.create( $fade_effect );

            elementWatcher.enterViewport( function() {

                TweenMax.staggerTo( ".element-item a", 1, { opacity: 1 }, 0.1 );

            } );
        } );

        $fade_in_effects = $( ".tweenmax-effect" );

        $fade_in_effects.each( function() {

            var $fade_effect = $( this );
            var elementWatcher = scrollMonitor.create( $fade_effect );

            elementWatcher.enterViewport( function() {

                TweenMax.staggerTo( ".tweenmax-effect", 1, { opacity: 1 }, 0.2 );

            } );
        } );


    // TweenMax.staggerTo()

    // FadeIn bottom top left right

      $fade_in_effects = $( ".fade_in_opacity, .fade_in_bottom_top, .fade_in_top_bottom, .fade_in_left_right, .fade_in_right_left" );

        $fade_in_effects.each( function() {

            var $fade_effect = $( this );
            var elementWatcher = scrollMonitor.create( $fade_effect );
            elementWatcher.enterViewport( function() {

                $fade_effect.addClass( "original_position_effects" );
            } );

            elementWatcher.exitViewport( function() {
                $fade_effect.css( {

                   // "transform": "scale(0)"
                } );
            } );
        } );

    // END fadein bottom top left right


    // BOUNCE left to right

      $fade_in_effects = $( ".timeline-left" );

        $fade_in_effects.each( function() {

            var $fade_effect = $( this );
            var elementWatcher = scrollMonitor.create( $fade_effect );
            elementWatcher.enterViewport( function() {

                $fade_effect.addClass( "bounce_left_right" );
            } );

        } );

    // END BOUNCE left to right


    // BOUNCE right to left

      $fade_in_effects = $( ".timeline-right" );

        $fade_in_effects.each( function() {

            var $fade_effect = $( this );
            var elementWatcher = scrollMonitor.create( $fade_effect );
            elementWatcher.enterViewport( function() {

                $fade_effect.addClass( "bounce_right_left" );
            } );

        } );

    // END BOUNCE right to left

    // BOUNCE popup

      $fade_in_effects = $( ".timeline__year" );

        $fade_in_effects.each( function() {

            var $fade_effect = $( this );
            var elementWatcher = scrollMonitor.create( $fade_effect );
            elementWatcher.enterViewport( function() {

                $fade_effect.addClass( "bounce__popup" );
            } );

        } );

    // END BOUNCE popup


  // END ANIMATE EFFECTS

} );



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/scroll_effect.js
 ** module id = 147
 ** module chunks = 0
 **/